import { render, staticRenderFns } from "./customer-upload-cert-dialog.vue?vue&type=template&id=55a353f0&"
import script from "./customer-upload-cert-dialog.vue?vue&type=script&lang=js&"
export * from "./customer-upload-cert-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports